import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPosition } from "../positionModal";

export const getAllPosition = createAsyncThunk(
  "Position/FindAllPosition",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/FindAllPosition`,
        {
          CustomerName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Position:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPosition = createAsyncThunk(
  "Position/InsertPosition",
  async (PositionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/InsertPosition`,
        PositionData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Position:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePosition = createAsyncThunk(
  "Position/UpdatePosition",
  async (PositionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/UpdatePosition`,
        PositionData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Position:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePosition = createAsyncThunk(
  "Position/DeletePosition",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/DeletePosition`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Position :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPositionByID = createAsyncThunk(
  "Position/FindByIDPosition",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/FindByIDPosition`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as IPosition;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePosition = createAsyncThunk(
  "Position/FindAllActivePosition",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Position/FindAllActivePosition`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactivePosition = createAsyncThunk(
  "Position/ActiveInActivePosition",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Position/ActiveInActivePosition`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Position :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
